import { AppView } from '@reducers/ui/location';
import analytics from '@support/analytics';

const trackNoteAction = (action: 'Created' | 'Edited', response: any, source: AppView) => {
  analytics.track(`Note ${action}`, {
    contactId: response.contact,
    noteId: response.id,
    source,
  });
};

// This should be broken into a separate file. Is there any matching we can do to simplify this
// and get new tracking dispatch for free?
export const appAlerts = (_store) => (next) => (action) => {
  const { type, payload } = action;

  switch (type) {
    case 'CREATE_CONTACT_SUCCEEDED':
      analytics.track('Contact Created', { contactId: payload.response.id, source: 'Home' });
      break;

    case 'UPDATE_CURRENTLY_EDITING_NOTE_SUCCEEDED':
      trackNoteAction('Edited', payload.response, payload.view);
      break;

    case 'CREATE_NOTE_SUCCEEDED':
    case 'CREATE_CURRENTLY_EDITING_NOTE_SUCCEEDED':
      trackNoteAction('Created', payload.response, payload.view);
      break;

    case 'DELETE_CONTACT_BATCH_SUCCEEDED':
      analytics.track('Contact Deleted', { contacts: payload.contact_ids, source: payload.source });
      break;

    case 'MERGE_CONTACT_BATCH_SUCCEEDED':
      analytics.track('Contact Merged', {
        contacts: payload.mergedContactIDs,
        source: payload.source,
      });
      break;

    default:
      break;
  }

  return next(action);
};
